<template>
    <CForm>
        <slot />
    </CForm>
</template>

<script>
import { CForm } from '@coreui/vue-pro'

export default {
    name: 'DForm',
    components: { CForm }
}
</script>
